<template>
  <Modal :open="open" @close="close">
    <div>
      <div class="text-center">
        <h2 class="text-lg font-semibold text-gray-900">Modifier les notes internes liées au sinistre</h2>
      </div>

      <div class="mb-6">
        <FormField
          id="internalNotes"
          name="internalNotes"
          v-model="internalNotes"
          label="Notes internes"
          label-class="block text-sm font-medium leading-6 text-gray-900"
          :required="true"
        />
      </div>

      <div class="flex justify-center space-x-4">
        <SecondaryButton @click="update">Confirmer</SecondaryButton>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Modal, SecondaryButton, FormField } from "@estaly/ui";
import { mapActions } from "vuex";

export default {
  components: { Modal, SecondaryButton, FormField },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    claim: {
      type: Object,
      required: true,
    },
  },

  data: () => {
    return {
      internalNotes: "",
    };
  },

  computed: {
    lastClaimFirstHistoricalData() {
      return this.claim?.claimHistoricalDatas?.[0];
    },
  },

  mounted() {
    this.internalNotes = this.lastClaimFirstHistoricalData?.internalNotes || "";
  },

  methods: {
    ...mapActions("claims", ["updateEstalyManagerNotes"]),
    ...mapActions("notifications", ["notify"]),

    async update() {
      const response = await this.updateEstalyManagerNotes({
        id: this.lastClaimFirstHistoricalData.id,
        internalNotes: this.internalNotes,
      });

      if (!response?.success) return;

      this.notify({
        category: "simple",
        type: "success",
        title: "Notes internes modifiées avec succès",
      });

      this.$emit("updated");
      this.close();
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>
